// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dimmed {\n  z-index: 901 !important;\n}\n.bsa .sitemap {\n  width: 340px;\n  background-color: #A985C6;\n}\n.bsa .sitemap .sitemap_header {\n  background-color: #A985C6;\n}\n.bsa .sitemap .sitemap_content {\n  background-color: #A985C6;\n}\n", ""]);
// Exports
module.exports = exports;
